export enum ActivitySentimentLevel {
  UNKNOWN = "UNKNOWN",
  NEUTRAL = "NEUTRAL",
  POSITIVE = "POSITIVE",
  NEGATIVE = "NEGATIVE",
}
